<ng-container *ngIf="footerContent$ | async as footer">
  <div class="columns w-100 px-3 py-4">
    <ng-container *ngFor="let column of footer.columns">
      <ng-container *ngIf="showAccordion$ | async; else columnView">
        <atx-accordion
          *ngIf="column.type === footerColumnType.LINKS; else footerSocialLine"
          [closeOthers]="true"
          class="w-auto mb-2"
        >
          <atx-accordion-panel [content]="links">
            <atx-accordion-header [ngTemplateOutlet]="header">
            </atx-accordion-header>
          </atx-accordion-panel>
        </atx-accordion>
      </ng-container>

      <ng-template #columnView>
        <div
          *ngIf="column.type === footerColumnType.LINKS; else footerSocialLine"
        >
          <ng-container [ngTemplateOutlet]="header"></ng-container>
          <ng-container [ngTemplateOutlet]="links"></ng-container>
        </div>
      </ng-template>

      <ng-template #header>
        <div data-e2e="header-container" class="header-container d-flex">
          <ng-container [ngTemplateOutlet]="columnTitle"></ng-container>
          <fa-icon
            [icon]="['fas', 'angle-right']"
            class="d-md-none ml-auto"
          ></fa-icon>
        </div>
      </ng-template>

      <ng-template #links>
        <a
          *ngFor="let link of column.links"
          class="sub-link nav-link d-block text-muted text-left p-0 mb-1 h-auto"
          [attr.href]="link.href | safeUrl"
          [attr.target]="isSameDomain(link.href) ? undefined : '_blank'"
        >
          {{ link.text }}
        </a>
      </ng-template>

      <ng-template #footerSocialLine>
        <div class="social-column-line">
          <ng-container [ngTemplateOutlet]="columnTitle"></ng-container>
          <div class="social-links">
            <a
              *ngFor="let link of column.links"
              [attr.href]="socialLinkHref(link)"
              target="_blank"
              class="nav-link d-inline-block p-0"
            >
              <fa-icon [icon]="socialLinkIcons[link.site]" size="1x"></fa-icon>
            </a>
          </div>
        </div>
      </ng-template>

      <ng-template #columnTitle>
        <span
          data-e2e="support-column"
          class="text-body h-auto d-inline-block text-left p-0"
        >
          <strong>
            {{ column.title }}
          </strong>
        </span>
      </ng-template>
    </ng-container>
  </div>
</ng-container>

<div
  data-e2e="current-year"
  class="bottom-line d-flex border-top p-3 text-muted"
>
  <span
    i18n="
      content|footer copyright and space
      characters@@contentFooterCopyrightAndSpaceChacarters"
  >
    &#169;&nbsp;
  </span>
  <span>{{ thisYear }}&nbsp;</span>
  <span i18n="layout|footer all rights reserved@@layoutFooterAllRightsReserved">
    All rights reserved
  </span>
</div>
